import { Route } from '../../route.model';
import MemberProfile from '@/views/Portal/MemberProfile.vue';

const portalMemberProfile = new Route(
  '/portal/member-profile/:customerId',
  'portal-member-profile',
  MemberProfile,
  {
    requiresAuth: true,
    isResponsive: true,
    zendesk: {
      disabled: true
    }
  }
);

export { portalMemberProfile };
export default portalMemberProfile;
